var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-md-editor',{staticClass:"mavonEditor",attrs:{"disabled-menus":[]},on:{"upload-image":_vm.handleUploadImage},model:{value:(_vm.newContent),callback:function ($$v) {_vm.newContent=$$v},expression:"newContent"}})
}
var staticRenderFns = []

export { render, staticRenderFns }